import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { useDispatch } from 'react-redux'
import { useForm } from 'react-hook-form'
import ModalContainer from '../Modals/ModalContainer'
import { MUIFormTextInput } from '../@Common/Form/TextInput/FormTextInput'
import { hideModal, showErrorNotification, showSuccessNotification } from '../../redux/actions'

function PartnerCreateModal({ onClickCreatePartner, onClickClose }) {
  const dispatch = useDispatch()
  const [processing, setProcessing] = useState(false)

  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      partnerName: '',
    },
  })
  const watchedPartnerName = watch('partnerName')

  const handleCreatePartner = handleSubmit(async (data) => {
    setProcessing(true)
    try {
      const result = await onClickCreatePartner({ name: data.partnerName, source: 'PartnersAdmin', sourceKey: '' })
      if (result.success) {
        dispatch(showSuccessNotification('Partner created successfully.'))
        dispatch(hideModal())
      } else {
        dispatch(showErrorNotification('Something went wrong creating the partner. Please try again later.'))
      }
    } catch {
      dispatch(showErrorNotification('Something went wrong creating the partner. Please try again later.'))
    } finally {
      setProcessing(false)
    }
  })

  return (
    <ModalContainer
      title="Create New Partner"
      maxWidth="sm"
      fullWidth="true"
      modal
      onClose={onClickClose}
      processing={processing}
      actions={{
        primaryAction: {
          label: 'Create',
          onClick: handleCreatePartner,
          disabled: !watchedPartnerName?.trim(),
        },
        secondaryAction: { label: 'Cancel', onClick: onClickClose },
      }}
    >
      <Box>
        <MUIFormTextInput
          name="partnerName"
          control={control}
          label="Partner Name"
          gxid="partnerName"
          autoFocus
          rules={{
            required: 'Partner name is required',
            maxLength: { value: 100, message: 'Partner name must be at most 100 characters' },
          }}
        />
      </Box>
    </ModalContainer>
  )
}

PartnerCreateModal.propTypes = {
  onClickCreatePartner: PropTypes.func.isRequired,
  onClickClose: PropTypes.func.isRequired,
}

export default PartnerCreateModal
